<template>
  <div>
    <v-container>
      <v-form
        lazy-validation
        @submit.prevent="onConfirm"
        v-model="valid"
        ref="form"
      >
        <v-row>
          <v-col> {{ faixaId ? "Editar" : "Criar" }} Faixa</v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Nome"
              name="nome"
              type="text"
              required
              v-model="payload.faixaNome"
              :rules="[obrigatorio]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Subsídio"
              name="subsidio"
              type="number"
              required
              v-model="payload.faixaSubsidio"
              :rules="[obrigatorio]"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Subsídio Premium"
              name="subsidioPremium"
              type="number"
              required
              v-model="payload.subsidioPremium"
              :rules="[obrigatorio]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-currency-field
              label="Teto"
              :prefix="'R$'"
              hide-details="auto"
              v-model="payload.faixaTeto"
              :rules="[obrigatorio]"
            />
          </v-col>
          <v-col>
            <v-currency-field
              label="Valor do Combo Essencial"
              :prefix="'R$'"
              hide-details="auto"
              v-model="payload.valorFaixaEssencial"
              :rules="[obrigatorio]"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="solutions"
              class="elevation-1"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.nome="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ diminuirValue(item.nome) }}</span
                    >
                  </template>
                  <span>{{ item.nome }} </span>
                </v-tooltip>
              </template>
              <template v-slot:item.grupoSolucao.nome="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ diminuirValue(item.grupoSolucao.nome) }}</span
                    >
                  </template>
                  <span>{{ item.nome }} </span>
                </v-tooltip>
              </template>

              <template v-slot:item.preco="{ item }">
                <v-currency-field
                  :prefix="'R$'"
                  hide-details="auto"
                  v-model="item.precoFaixa"
                />
              </template>

              <template v-slot:item.custo="{ item }">
                <v-currency-field
                  :prefix="'R$'"
                  hide-details="auto"
                  v-model="item.custoFaixa"
                />
              </template>
              <template slot="no-data">
                <span> Nenhuma Solução retornada </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="buttons">
              <v-btn color="error" outlined text @click="goBack()"
                >Cancelar</v-btn
              >
              <v-btn color="info" outlined text @click="onConfirm"
                >Salvar</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>
<script>
import { faixaApi, faixaSolucaoApi } from "@/apis";

import { solutionAPI } from "@/modules/solution";
import { mapActions } from "vuex";
import { compare } from "@/helpers/orderByAsc";

export default {
  name: "CriarProposta",

  components: {},
  data() {
    return {
      payload: {},
      dialog: false,
      faixaId: this.$route.params.id,
      solutions: [],
      valid: true,

      headers: [
        { text: "Grupo", value: "grupoSolucao.nome" },

        { text: "Solução", value: "nome" },
        { text: "Preço", value: "preco" },
        { text: "Custo", value: "custo" },
      ],
      obrigatorio: (v) => {
        if (!v) return "Campo Obrigatório";

        return true;
      },
    };
  },
  mounted() {
    this.payload = {};
    if (this.faixaId) {
      this.getFaixa();
    } else {
      this.loadSolutions();
    }
  },

  methods: {
    ...mapActions(["setLoading"]),

    diminuirValue(item) {
      if (item && item.length > 50) {
        return item.substring(0, 50) + "...";
      }

      return item;
    },
    getFaixa() {
      this.setLoading(true);
      faixaApi.get(this.faixaId).then((res) => {
        this.payload = res.data;
        const solucoesPrecos =
          (res.data &&
            res.data.solucoesFaixasDTO &&
            res.data.solucoesFaixasDTO.length &&
            res.data.solucoesFaixasDTO) ||
          [];
        this.loadSolutions(solucoesPrecos);
        this.setLoading(false);
      });
    },
    loadSolutions(solucoesPrecos) {
      this.setLoading(true);
      solutionAPI.list({}).then((res) => {
        this.solutions = res.data
          .map((item) => ({ ...item, grupoNome: item.grupoSolucao.nome }))
          .sort((a, b) => compare(a, b, "grupoNome"));

        if (solucoesPrecos && solucoesPrecos.length) {
          this.solutions = this.solutions.map((val) => {
            const solucaoAtual = solucoesPrecos.find(
              (a) => a.solucaoId == val.solucaoId
            );
            return {
              ...val,
              precoFaixa: (solucaoAtual && solucaoAtual.preco) || undefined,
              custoFaixa: (solucaoAtual && solucaoAtual.custo) || undefined,
              solucaoFaixaid:
                (solucaoAtual && solucaoAtual.solucaoFaixaid) || undefined,
            };
          });
        }

        this.setLoading(false);
      });
    },
    goBack() {
      this.$router.push("/faixas");
    },
    addFaixaSolucoes(faixaSolucao) {
      faixaSolucaoApi
        .create(faixaSolucao)
        .then((resp) => {})
        .catch((err) => {
          console.log("🚀 ~ addFaixaSolucoes ~ err:", err);

          this.$notification.error("Erro ao salvar valor das soluções");
        });
    },
    async onConfirm() {
      const validate = await this.$refs.form.validate();
      if (!validate) {
        document.querySelector("[class*='error']").scrollIntoView();
        window.scrollTo({
          top: 100,
        });
        return;
      }

      const filteredSolution = this.solutions.filter(
        (item) => item.precoFaixa && item.custoFaixa
      );

      this.setLoading(true);

      if (this.faixaId) {
        this.payload.solucoesFaixasDTO = filteredSolution.map((item) => ({
          solucaoId: item.solucaoId,
          solucaoFaixaid: item.solucaoFaixaid,
          faixaId: this.faixaId,
          preco: item.precoFaixa,
          custo: item.custoFaixa,
        }));
        faixaApi
          .update(this.payload)
          .then((resp) => {
            this.setLoading(false);

            this.goBack();
          })
          .catch((err) => {
            console.log("🚀 ~ onConfirm ~ err:", err);
            this.setLoading(false);

            this.$notification.error("Erro ao salvar faixas");
          });
      } else {
        this.payload.solucoesFaixasDTO = filteredSolution.map((item) => ({
          solucaoId: item.solucaoId,
          preco: item.precoFaixa,
          custo: item.custoFaixa,
        }));

        faixaApi
          .create(this.payload)
          .then((resp) => {
            this.setLoading(false);

            this.goBack();
          })
          .catch((err) => {
            console.log("🚀 ~ onConfirm ~ err:", err);
            this.setLoading(false);

            this.$notification.error("Erro ao salvar faixas");
          });
        this.payload = {};
      }
    },
    close() {
      this.payload = {};
      this.dialog = false;
    },
  },
};
</script>

<style>
.buttons {
  display: flex;
  column-gap: 10px;
  margin-left: auto;
  width: fit-content;
}
</style>
